import { DocumentTextIcon } from '@heroicons/react/24/outline';
import type { SelectedFile } from '../../types';

export function AttachmentItem({
  haveFiles,
  haveFilesDescription,
  selectedFiles,
  getFileUrl,
  title,
}: {
  title: string;
  haveFiles: boolean;
  haveFilesDescription: string;
  selectedFiles: SelectedFile[];
  getFileUrl: (key: string) => string;
}) {
  return (
    <>
      <dt className='text-sm font-medium text-gray-500'>{title}</dt>
      {selectedFiles.length === 0 && haveFiles ? (
        <p className='mt-1'>{haveFilesDescription}</p>
      ) : (
        <div>
          {selectedFiles
            .filter((file) => !!file && Object.keys(file).length > 0)
            .map((file, index) => (
              <a key={index} href={getFileUrl(file.key)} target='_blank' rel='noreferrer' download>
                <dd className='mt-1 gap-1 text-sm text-gray-900 normal-case flex hover:underline cursor-pointer w-full'>
                  <span>
                    <DocumentTextIcon className='grow min-w-5 w-5 h-5 text-neutralColor-normal' />
                  </span>
                  <div className='flex-1 flex items-center max-w-[calc(100%-1.25rem)]'>
                    <span className='whitespace-nowrap overflow-hidden text-ellipsis'>{file?.name?.split('.').at(0)}</span>
                    <span>.{file?.name?.split('.').at(-1)}</span>
                  </div>
                </dd>
              </a>
            ))}
        </div>
      )}
    </>
  );
}
